"use client";

import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";
import {
  applyChunkLoadDiagnosticsToScope,
  prepareChunkLoadDiagnosticsForCapture,
} from "@/lib/chunk-load-diagnostics";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    void (async () => {
      await prepareChunkLoadDiagnosticsForCapture();

      Sentry.withScope((scope) => {
        scope.setTag("errorBoundary", "GlobalError");
        applyChunkLoadDiagnosticsToScope(scope, error);
        Sentry.captureException(error);
      });
    })();
  }, [error]);

  return (
    <html>
      <body>
        <div className="flex bg-background min-h-screen flex-col items-center justify-center">
          <h1 className="text-4xl font-bold text-gray-900">
            Something went wrong!
          </h1>
          <p className="mt-4 text-lg text-gray-600">
            An unexpected error occurred
          </p>
          <button
            onClick={reset}
            className="mt-6 rounded-md bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
          >
            Try again
          </button>
        </div>
      </body>
    </html>
  );
}
